/**
 * Google Identity Services 脚本加载器。
 * 不使用 npm 包，避免为一次登录引入依赖。
 */
let gisPromise: Promise<any> | null = null;

export const GOOGLE_CLIENT_ID = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? "";

export function loadGoogleIdentity(): Promise<any> {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Google Identity Services requires a browser"));
  }
  if (gisPromise) return gisPromise;

  gisPromise = new Promise((resolve, reject) => {
    const existing = (window as any).google;
    if (existing?.accounts?.id) {
      resolve(existing);
      return;
    }
    const timer = setTimeout(() => {
      gisPromise = null;
      reject(new Error("Google Identity Services 加载超时"));
    }, 8000);
    const script = document.createElement("script");
    // hl 固定中文，避免按钮/弹窗跟随浏览器语言显示英文
    script.src = "https://accounts.google.com/gsi/client?hl=zh_CN";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      clearTimeout(timer);
      const g = (window as any).google;
      if (g?.accounts?.id) resolve(g);
      else {
        gisPromise = null;
        reject(new Error("Google Identity Services loaded but unavailable"));
      }
    };
    script.onerror = () => {
      clearTimeout(timer);
      gisPromise = null;
      reject(new Error("加载 Google 登录脚本失败"));
    };
    document.head.appendChild(script);
  });
  return gisPromise;
}

/**
 * 预热 GIS 脚本：页面空闲时即开始下载并缓存 gisPromise，
 * 这样用户首次打开登录弹窗时无需再等待网络往返，按钮几乎即时出现。
 * 仅在配置了 GOOGLE_CLIENT_ID 时才发起请求。
 */
export function preloadGoogleIdentity(): void {
  if (GOOGLE_CLIENT_ID) {
    void loadGoogleIdentity().catch(() => {});
  }
}
